/**
 * Validación de patentes argentinas (formatos vigentes y anteriores) para autos
 * y motos. Es el espejo de `gestion-api-gestion/src/auxiliares/soflex/patente.ts`:
 * la sincronización con Soflex descarta los vehículos cuya patente no matchea
 * alguno de estos formatos, así que el formulario avisa antes de guardar.
 *
 * En el front es sólo una advertencia: se puede guardar cualquier valor (hay
 * flotas sin patente o con identificadores internos).
 *
 *   ABC123   auto, formato anterior
 *   AA123AA  auto, formato Mercosur
 *   123ABC   moto, formato anterior
 *   A123BCD  moto, formato Mercosur
 *   ABC12    maquinaria agrícola / vial
 */
const FORMATOS_PATENTE: RegExp[] = [
  /^[A-Z]{3}\d{3}$/, // Auto vieja
  /^[A-Z]{2}\d{3}[A-Z]{2}$/, // Auto nueva (Mercosur)
  /^\d{3}[A-Z]{3}$/, // Moto vieja
  /^[A-Z]\d{3}[A-Z]{3}$/, // Moto nueva (Mercosur)
  /^[A-Z]{3}\d{2}$/, // Maquinaria (3 letras + 2 números)
];

/** Mayúsculas y sin espacios ni guiones, igual que antes de enviar a Soflex */
export function normalizarPatente(patente?: string | null): string {
  return (patente || '').toUpperCase().replace(/[\s.-]/g, '');
}

export function esPatenteArgentinaValida(patente?: string | null): boolean {
  const normalizada = normalizarPatente(patente);
  return FORMATOS_PATENTE.some((formato) => formato.test(normalizada));
}
